import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { nav, logo, company } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setExpanded(null);
  }, [location.pathname, location.hash]);

  return (
    <header className={`mh-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="mh-topbar">
        <div className="mh-container mh-topbar-inner">
          <span>{company.address}, {company.cityStateZip}</span>
          <a href={company.phoneHref} className="mh-topbar-phone">
            <Phone size={14} /> {company.phone}
          </a>
        </div>
      </div>
      <div className="mh-container mh-nav-inner">
        <Link to="/" className="mh-logo" aria-label="Monarch Homes of Brevard home">
          <img src={logo} alt="Monarch Homes of Brevard" />
        </Link>

        <nav className="mh-nav-desktop">
          {nav.map((item) => (
            <div key={item.to + item.label} className={`mh-nav-item ${item.children ? "has-children" : ""}`}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) => `mh-nav-link ${isActive ? "active" : ""}`}
              >
                {item.label}
                {item.children && <ChevronDown size={14} className="mh-nav-caret" />}
              </NavLink>
              {item.children && (
                <div className="mh-dropdown">
                  {item.children.map((c) => (
                    <NavLink key={c.to + c.label} to={c.to} className="mh-dropdown-link">
                      {c.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <a href={company.phoneHref} className="mh-cta-btn mh-nav-cta">Call Us</a>

        <button className="mh-burger" onClick={() => setOpen(true)} aria-label="Open menu">
          <Menu size={26} />
        </button>
      </div>

      <div className={`mh-mobile-panel ${open ? "open" : ""}`}>
        <div className="mh-mobile-head">
          <img src={logo} alt="Monarch Homes" className="mh-mobile-logo" />
          <button onClick={() => setOpen(false)} aria-label="Close menu"><X size={26} /></button>
        </div>
        <nav className="mh-mobile-links">
          {nav.map((item, idx) => (
            <div key={item.to + item.label} className="mh-mobile-group">
              <div className="mh-mobile-row">
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) => `mh-mobile-link ${isActive ? "active" : ""}`}
                >
                  {item.label}
                </NavLink>
                {item.children && (
                  <button
                    className={`mh-mobile-toggle ${expanded === idx ? "open" : ""}`}
                    onClick={() => setExpanded(expanded === idx ? null : idx)}
                    aria-label="Toggle submenu"
                  >
                    <ChevronDown size={20} />
                  </button>
                )}
              </div>
              {item.children && expanded === idx && (
                <div className="mh-mobile-sub">
                  {item.children.map((c) => (
                    <NavLink key={c.to + c.label} to={c.to} className="mh-mobile-sublink">
                      {c.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
          <a href={company.phoneHref} className="mh-cta-btn" style={{ marginTop: 16 }}>
            <Phone size={16} /> {company.phone}
          </a>
        </nav>
      </div>
      {open && <div className="mh-overlay" onClick={() => setOpen(false)} />}
    </header>
  );
};

export default Header;
